<template>
  <page title="Magazine / Issue purchases" :back-to="getPreviousUrl" >

    <div class="box">
      <b-field>
        <b-input
          @blur="searchChanged()"
          :placeholder="$tc('dater.range')"
          type="search"
          v-model="query"
          icon="magnify"
          icon-clickable
          @input="(search) => purchases.filter({ search }).load()"
          expanded
        ></b-input>
      </b-field>

      <b-table
        :data="purchases.data"
        :loading="purchases.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :current-page="purchases.current_page"
        :per-page="purchases.per_page"
        :total="purchases.total"
        @page-change="page => purchases.changePage(page)"
        backend-sorting
        @sort="(field, direction) => purchases.sort(field, direction)"
        :default-sort="['id', 'desc']"
        class="is-middle">
        <template slot-scope="props">
          <b-table-column field="id" label="#" sortable width="80">{{ props.row.id }}</b-table-column>

          <b-table-column label="User">{{ props.row.user.email }}</b-table-column>
          <b-table-column label="Magazine">
            <router-link
              :to="`/magazine/magazines/${props.row.issue.magazine_id}/edit`"
              class="has-text-grey mr-2"
            >{{ props.row.issue.magazine.name }} /
            </router-link
            >

            <router-link
              :to="`/magazine/magazine/issues/${props.row.issue.id}/edit`"
              class="has-text-dark"
              size="is-large"
            >{{ props.row.issue.title }}
            </router-link
            >
          </b-table-column>
          <b-table-column label="Method">
            {{ props.row.method }}
            <br/>

            <span
              class="tag"
              v-if="props.row.method === 'web-purchase'"
            >{{ props.row.web_receipt_id }}</span>
          </b-table-column>

          <b-table-column field="created_at" label="Created At" sortable>
            {{ props.row.created_at | dateTime }}
          </b-table-column>

          <b-table-column custom-key="actions" width="200">
            <div class="is-pulled-right">
              <button class="button" @click="revoke(props.row)">
                Revoke
              </button>
            </div>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>

import AddActivationModal from "@/modules/admin/pages/magazine/issue-activations/AddAccessModal";

export default {
  data() {
    return {
      query: localStorage.getItem('activation-search') || '',
      purchases: new window.PaginatedRemoteCollection(
        `/admin/api/magazine/issue-activations/${this.$route.params.id}`
      )
    };
  },

  created() {
    this.purchases.filter({ search: this.query }).load();
  },

  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },

  methods: {
    searchChanged() {
      localStorage.setItem('activation-search', this.query);
    },

    create() {
      this.$buefy.modal.open({
        component: AddActivationModal,
        props: {
          added: () => this.purchases.load(),
        },
      });
    },

    revoke(access) {
      this.$buefy.dialog.confirm({
        title: "Are you sure?",
        message: "Revoking issue activation access.",
        cancelText: "Cancel",
        confirmText: "Revoke",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          new window.Form()
            .delete(`/admin/api/magazine/issue-activations/${access.id}`)
            .then(this.revoked);
        },
      });
    },

    revoked() {
      this.purchases.load();
      this.$buefy.toast.open("Issue activation revoked");
    },
  }
};
</script>
